module.exports = __webpack_public_path__ + "static/media/logo.c84f18e5.png";